/**
 * Shared by every invite-acceptance flow that mints a session via a Clerk
 * sign-in ticket (team invite, admin/partner invite): a passwordless Clerk
 * user with no SSO connection can never sign back in once the session ends,
 * so the caller must route them through password setup before treating
 * sign-in as complete.
 */
export function userNeedsPassword(user: {
  passwordEnabled?: boolean;
  externalAccounts?: ReadonlyArray<unknown>;
}): boolean {
  const passwordSet = user.passwordEnabled ?? true;
  const hasSso = (user.externalAccounts?.length ?? 0) > 0;
  return !passwordSet && !hasSso;
}
